// Fetches colormap JSON files referenced from scene.json `colormaps[]` and
// merges their stop arrays into the supplied `defs` map. Async; safe to skip
// if the scene declares no colormaps.

import type { SceneJson } from '../sceneIO/parsers';

interface ColormapDef { name: string; url: string }

export async function loadColormapsFromScene(
    sceneConf: SceneJson,
    defs: Record<string, unknown>,
    opts: { debugEnabled?: boolean } = {},
): Promise<void> {
    try {
        if (!sceneConf || !Array.isArray(sceneConf['colormaps'])) return;
        const entries = sceneConf['colormaps'] as ColormapDef[];
        const loads = entries.map(async (e) => {
            const res = await fetch(e.url, { cache: 'no-cache' });
            if (!res.ok) throw new Error(`Failed loading colormap ${e.name}: ${res.status}`);
            const json = await res.json() as { name?: string; colors?: unknown[] };
            const key = e.name || json.name || e.url;
            const colors = Array.isArray(json.colors) ? json.colors : [];
            defs[key] = colors;
        });
        await Promise.all(loads);
        if (opts.debugEnabled) console.log('Loaded colormaps:', Object.keys(defs));
    } catch (err) {
        if (opts.debugEnabled) console.warn('Colormap load error:', err);
    }
}
